<template>
  <div>
    <base-title
      :title="printer.name"
      :subtitle="StringLanguage.printers"
      :link="'impressoras'"
    />

    <div class="row">
      <div
        class="col-lg-4 col-xs-12"
        v-for="(layout, index) in printer.layouts"
        :key="index"
      >
        <!-- v-for aqui -->
        <base-box>
          <div
            class="d-flex justify-between align-center"
            @click="editVia(index)"
          >
            <base-label :text="layout.name"></base-label>
            <p class="edit-name"><i class="fas fa-cog"></i></p>
          </div>

          <div class="print">
            <div
              class="block"
              :class="{ checked: printer.layouts[index].blocks.header }"
              @click="enableDisableBloclk('header', index)"
            >
              <p>{{ StringLanguage.header }}</p>
              <p
                v-if="printer.layouts[index].blocks.header"
                class="check-block"
              >
                <i class="fas fa-eye"></i>
              </p>
            </div>
            <div
              class="block block-customer"
              :class="{ checked: printer.layouts[index].blocks.customer }"
              @click="enableDisableBloclk('customer', index)"
            >
              <p>{{ StringLanguage.clientData }}</p>
              <p
                v-if="printer.layouts[index].blocks.customer"
                class="check-block"
              >
                <i class="fas fa-eye"></i>
              </p>
            </div>
            <div class="row">
              <div class="col-lg-8 col-xs-8">
                <div
                  class="block block-products"
                  :class="{ checked: printer.layouts[index].blocks.products }"
                  @click="enableDisableBloclk('products', index)"
                >
                  <p>{{ StringLanguage.products }}</p>
                  <p
                    v-if="printer.layouts[index].blocks.products"
                    class="check-block"
                  >
                    <i class="fas fa-eye"></i>
                  </p>
                </div>
              </div>
              <div class="col-lg-4 col-xs-4 pl_0">
                <div
                  class="block block-products"
                  :class="{
                    checked: printer.layouts[index].blocks.productsValue,
                  }"
                  @click="enableDisableBloclk('productsValue', index)"
                >
                  <p>{{ StringLanguage.values }}</p>
                  <p
                    v-if="printer.layouts[index].blocks.products"
                    class="check-block"
                  >
                    <i class="fas fa-eye"></i>
                  </p>
                </div>
              </div>
            </div>
            <div
              class="block block-customer mt_20"
              :class="{ checked: printer.layouts[index].blocks.payment }"
              @click="enableDisableBloclk('payment', index)"
            >
              <p>{{ StringLanguage.payment }}</p>
              <p
                v-if="printer.layouts[index].blocks.payment"
                class="check-block"
              >
                <i class="fas fa-eye"></i>
              </p>
            </div>
            <div
              class="block mt_20"
              :class="{ checked: printer.layouts[index].blocks.address }"
              @click="enableDisableBloclk('address', index)"
            >
              <p>{{ StringLanguage.address }}</p>
              <p
                v-if="printer.layouts[index].blocks.address"
                class="check-block"
              >
                <i class="fas fa-eye"></i>
              </p>
            </div>
            <div
              class="block mt_20"
              :class="{ checked: printer.layouts[index].blocks.footer }"
              @click="enableDisableBloclk('footer', index)"
            >
              <p>{{ StringLanguage.footer }}</p>
              <p
                v-if="printer.layouts[index].blocks.footer"
                class="check-block"
              >
                <i class="fas fa-eye"></i>
              </p>
            </div>
          </div>

          <!-- <base-button :text="'Categorias visiveis'" :design="'two'" class="mt_20 w-100"/> -->

          <!-- <div class="mt_20">
                <div class="row">
                    <div class="col-lg-6 col-xs-6">
                        <base-button :text="'Momentos de disparo'"/>
                    </div>
                    <div class="col-lg-6 col-xs-6">
                        <base-button :text="'Categorias visiveis'"/>
                    </div>
                </div>
            </div> -->
        </base-box>
      </div>

      <div class="col-lg-4 col-xs-12">
        <base-add
          :text="StringLanguage.addVia"
          class="add-via"
          @click.native="addVia"
        />
      </div>
    </div>

    <base-drawer
      :title="StringLanguage.changeVia"
      :open="edit"
      :close="editClose"
    >
      <base-tabs
        :tabs="[
          { name: StringLanguage.configurations, value: 0 },
          { name: StringLanguage.categories, value: 1 },
        ]"
        @change="changeTab"
      />

      <div v-if="tabActive === 0">
        <!-- Tab configurações -->
        <base-card>
          <p class="question">{{ StringLanguage.configureYourVia }}:</p>
          <base-input
            :label="StringLanguage.viaName"
            v-if="printer.layouts[layoutIndex]"
            v-model="printer.layouts[layoutIndex].name"
          ></base-input>
          <base-textarea
            :label="StringLanguage.header"
            v-if="printer.layouts[layoutIndex]"
            rows="4"
            v-model="printer.layouts[layoutIndex].header"
            class="mb_15"
          ></base-textarea>
          <base-textarea
            :label="StringLanguage.footer"
            v-if="printer.layouts[layoutIndex]"
            rows="4"
            v-model="printer.layouts[layoutIndex].footer"
          ></base-textarea>
        </base-card>

        <base-card>
          <p class="question">{{ StringLanguage.firingTime }}:</p>
          <base-checkbox
            v-if="printer.layouts[layoutIndex]"
            :label="StringLanguage.whenAcceptingOrders"
            :checked="printer.layouts[layoutIndex].whenAcceptingOrders"
            v-model="printer.layouts[layoutIndex].whenAcceptingOrders"
            class="mb_15"
          />
          <!-- OCB <base-checkbox
            v-if="printer.layouts[layoutIndex]"
            :label="StringLanguage.whenEditingOrders"
            :checked="printer.layouts[layoutIndex].whenEditingOrders"
            v-model="printer.layouts[layoutIndex].whenEditingOrders"
            class="mb_15"
          /> OCB -->
          <base-checkbox
            v-if="printer.layouts[layoutIndex]"
            :label="StringLanguage.whenCancelingOrders"
            :checked="printer.layouts[layoutIndex].whenCancelingOrders"
            v-model="printer.layouts[layoutIndex].whenCancelingOrders"
            class="mb_15"
          />
          <!-- OCB <base-checkbox
            v-if="printer.layouts[layoutIndex]"
            :label="StringLanguage.whenOrderingByPhone"
            :checked="printer.layouts[layoutIndex].whenOrderingByPhone"
            v-model="printer.layouts[layoutIndex].whenOrderingByPhone"
            class="mb_15"
          />
          <base-checkbox
            v-if="printer.layouts[layoutIndex]"
            :label="StringLanguage.whenOrderingByServiceDesk"
            :checked="printer.layouts[layoutIndex].whenOrderingByServiceDesk"
            v-model="printer.layouts[layoutIndex].whenOrderingByServiceDesk"
            class="mb_15"
          /> OCB -->
          <base-checkbox
            v-if="printer.layouts[layoutIndex]"
            :label="'Impressão de 2ª via'"
            :checked="printer.layouts[layoutIndex].reprintTicket"
            v-model="printer.layouts[layoutIndex].reprintTicket"
          />
        </base-card>
      </div>
      <div v-if="tabActive === 1">
        <!-- Tab categorias -->
        <base-card>
          <p class="question">{{ StringLanguage.displayedCategories }}:</p>
          <base-checkbox
            v-for="(category, index) in categories"
            :key="index"
            :label="category"
            :checked="checkCategory(category)"
            @click="checkCategory(category, true)"
            class="mb_15"
          />
        </base-card>
      </div>

      <template slot="footer">
        <div class="d-flex">
          <base-button
            design="four"
            class="w-100 mr_15"
            :text="'Deletar'"
            @click="remove"
          />
          <base-button
            :text="StringLanguage.save"
            @click="save"
            class="w-100"
          />
        </div>
      </template>
    </base-drawer>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseLabel from '@/components/Label';
import BaseAdd from '@/components/Add';
import BaseDrawer from '@/components/Drawer';
import BaseTabs from '@/components/Tabs';
import BaseCard from '@/components/Card';
import BaseTextarea from '@/components/Textarea';
import BaseCheckbox from '@/components/Checkbox';

import StoreAPI from '@/api/store';
import CatalogAPI from '@/api/catalog';
import AppBridge from '@/plugins/app';

import Storage2 from '@/plugins/storage2';

export default {
  data() {
    return {
      edit: false,
      editClose: false,
      tabActive: 0,
      layoutIndex: 0,
      fakeVia: {
        name: StringLanguage.unnamedVia,
        header: 'Veasy Burritos',
        footer: StringLanguage.thankYouForYourPreference,
      },
      printer: {},
      categories: [],
      bluetoothConfig: Storage2.get('local', 'bluetoothConfigurations'),
    };
  },
  components: {
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseInput,
    BaseLabel,
    BaseAdd,
    BaseDrawer,
    BaseTabs,
    BaseCard,
    BaseTextarea,
    BaseCheckbox,
  },
  methods: {
    changeTab(current) {
      this.tabActive = current;
    },
    addVia() {
      const categories = {};
      for (const category of this.categories) {
        if (category) {
          categories[category] = true;
        }
      }

      const length =
        this.printer.layouts && this.printer.layouts.length > 0
          ? this.printer.layouts.length
          : 0;
      let viaName = 'Via padrão';

      if (length > 0) {
        let countViaWithoutName = 0;
        for (const layout of this.printer.layouts) {
          if (layout.name.includes('Via sem nome')) {
            countViaWithoutName += 1;
          }
        }

        const lastFinalString =
          countViaWithoutName > 0 ? `(${countViaWithoutName + 1})` : '';
        viaName = `Via sem nome ${lastFinalString}`;
      }

      this.printer.layouts.push({
        name: viaName,
        header: '',
        footer: '',
        blocks: {
          header: true,
          customer: true,
          products: true,
          productsValue: true,
          address: true,
          payment: true,
          footer: true,
        },
        whenAcceptingOrders: true,
        whenEditingOrders: true,
        whenCancelingOrders: true,
        whenOrderingByPhone: true,
        whenOrderingByServiceDesk: true,
        reprintTicket: true,
        categories,
      });

      this.save();

      this.$forceUpdate();
    },
    editVia(index) {
      this.edit = !this.edit;
      this.layoutIndex = index;
    },
    save() {
      // for (let i in this.printers) {
      //     if (this.printers[i].name == this.printer.name) {
      //         this.printers[i] = this.printers[i]
      //     }
      // }

      if (this.printer.bluetooth) {
        this.bluetoothConfig.printers.filter((item) => {
          if ((item.name = this.$route.params.name)) {
            item = this.printer;
          }
        });

        Storage2.set('local', 'bluetoothConfigurations', this.bluetoothConfig);
        AppBridge.emit('setBluetoothConfigurations', this.bluetoothConfig);
        this.editClose = !this.editClose;
      } else {
        StoreAPI.storeConfiguration({ printers: this.printers }, false).then(
          (response) => {
            this.editClose = !this.editClose;
          }
        );
      }
    },
    remove() {
      this.printer.layouts.splice(this.layoutIndex, 1);
      this.save();
    },
    enableDisableBloclk(block, index) {
      if (['products', 'productsValue'].includes(block)) {
        this.printer.layouts[index].blocks.products =
          !this.printer.layouts[index].blocks.products;
        this.printer.layouts[index].blocks.productsValue =
          !this.printer.layouts[index].blocks.productsValue;
      } else {
        this.printer.layouts[index].blocks[block] =
          !this.printer.layouts[index].blocks[block];
      }

      this.save();
      this.$forceUpdate();
    },
    checkCategory(category, set = false) {
      if (!this.printer.layouts[this.layoutIndex].categories) {
        this.printer.layouts[this.layoutIndex].categories = {};
      }

      if (set) {
        this.printer.layouts[this.layoutIndex].categories[category] =
          !this.printer.layouts[this.layoutIndex].categories[category];
      }

      return this.printer.layouts[this.layoutIndex].categories[category];
    },
  },
  created() {
    let printer = this.printers.filter((printer) => {
      if (printer.name == this.$route.params.name) {
        return printer;
      }
    });

    /** se bluetooth */
    if (printer.length == 0) {
      printer = this.bluetoothConfig.printers.filter(
        (item) => (item.name = this.$route.params.name)
      );
    }

    if (!printer[0].layouts) {
      printer[0].layouts = [];
    }

    this.printer = printer[0];

    CatalogAPI.catalogCatalog(true, true).then((response) => {
      const { items } = response._data;

      for (const i in items) {
        const categoryName = items[i].name;

        if (categoryName) {
          this.categories.push(categoryName);
        }
      }
    });
  },
  computed: {
    ...mapState({
      printers: (state) => state.printers.printers,
    }),
  },
};
</script>
<style scoped>
.edit-name {
  margin-bottom: 10px;
  font-size: 1.4em;
  color: var(--label-primary);
  cursor: pointer;
}
.print {
  background: var(--box-up);
  padding: 20px 15px;
  border-radius: 5px;
  margin-top: 15px;
  font-size: 1.4em;
}
.env-name {
  text-align: center;
}

.block {
  text-align: center;
  padding: 20px 15px;
  border: 1px dashed var(--label-primary);
  border-radius: 5px;
  color: var(--label-primary);
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.block:not(:last-child) {
  margin-bottom: 20px;
}
.block-customer {
  padding: 40px 15px;
}
.block-products {
  padding: 70px 15px;
}
.check-block {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 10px;
  background: var(--default);
  color: white;
  border-radius: 5px 0 0 0;
}
.block.checked {
  border: 1px solid var(--default);
  color: var(--default);
  font-weight: bold;
  background: var(--box);
}
.question {
  font-size: 1.6em;
  font-weight: 300;
  color: #999;
  margin-bottom: 30px;
}

.add-via {
  height: 735px;
}

/* RESPONSIVO */
@media (max-width: 991px) {
  .add-via {
    height: 200px;
  }
}
</style>
